"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCandid = exports.fromCandid = exports.toDate = void 0;
function toDate(value) {
    return new Date(Number(value));
}
exports.toDate = toDate;
function fromCandid(value) {
    return Number(value);
}
exports.fromCandid = fromCandid;
function toCandid(timestamp) {
    return BigInt(timestamp);
}
exports.toCandid = toCandid;
